import * as React from 'react'

const SendIcon = (props: { foreground: React.SVGProps<SVGPathElement>['fill'] }) => (
  <div style={{ width: 24, height: 24 }}>
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.83 4.995c.815-2.37-1.454-4.64-3.825-3.825L3.052 6.654c-2.684.922-2.717 4.705-.05 5.675l6.357 2.312 2.312 6.358c.97 2.667 4.753 2.632 5.675-.05L22.83 4.994zm-2.837-.976L14.51 19.973c-.003.01-.015.01-.019 0L12.5 14.5l1.783-4.458a.25.25 0 00-.325-.325L9.5 11.5 4.027 9.51a.01.01 0 010-.02L19.98 4.008a.01.01 0 01.012.012z"
        fill={props.foreground}
      />
    </svg>
  </div>
)

export default SendIcon
